export type LastName = string;
export const PATTERN = /^\D+$/;
